import { useLocation } from 'react-router-dom';
import { Link } from 'components/Link/Link';
import home from 'images/icons/whiteIcons/home.svg';
import './styles.scss';
import BreadcrumbItem from './BreadcrumbItem';

const Breadcrumbs = () => {
    const location = useLocation();
    const pathSegments = location.pathname.split('/').filter(segment => segment !== '');

    return (
        <div className="breadcrumbs">
            <BreadcrumbItem to="/">
                <img src={home} alt="home" />
            </BreadcrumbItem>
            <div className="breadcrumbs-dot"></div>
            {pathSegments.map((segment, index) => (
                <span key={segment} className="breadcrumbs-span">
                    <BreadcrumbItem to={`/${pathSegments.slice(0, index + 1).join('/')}`} className="body3">
                        {segment}
                    </BreadcrumbItem>
                    {index < pathSegments.length - 1 && <div className="breadcrumbs-dot margin-left"></div>}
                </span>
            ))}
        </div>
    );
};

export default Breadcrumbs;
